exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-list div[data-v-6edb80d8]{width:35px;height:35px;position:relative;display:inline-block;margin-right:7px}.avatar-list div img[data-v-6edb80d8]{width:35px;height:35px;background-image:url(/images/avatar.png);background-size:contain;text-indent:-9999px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6edb80d8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/AppAvatarList.vue
// module id = k/4b
// module chunks = 0